import {
	DATABASE_EXPERIENCE,
	EMBED_EXPERIENCE,
	VIEW_PAGE_EXPERIENCE,
	WHITEBOARD_EXPERIENCE,
} from '@confluence/experience-tracker';

export const PAGE_TYPES = new Set(['page', 'blogpost']);
export const IFRAME_TYPES = new Set(['whiteboard', 'database', 'embed']);
export const VALID_CONTENT_EXPERIENCES = new Set([
	DATABASE_EXPERIENCE,
	EMBED_EXPERIENCE,
	VIEW_PAGE_EXPERIENCE,
	WHITEBOARD_EXPERIENCE,
]);
